import { useDispatch, useSelector } from "react-redux";

import { selectDirtyFiltersFlag } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { saveSearchTriggerModalToggledAction } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/action-creators";

import useExportSearchTrigger from "./useExportSearchTrigger";

type HookResult = {
    isGuardConditionSatisfied: boolean;
};

/**
 * Registers the once-per-session "save your search?" trigger that fires after
 * the user performs an export with at least one filter applied. Returns the
 * guard flag so callers can skip mounting the prompt UI when the user has no
 * filters worth saving.
 */
const useSavedSearchTrigger = (): HookResult => {
    const dispatch = useDispatch();

    const isGuardConditionSatisfied = useSelector(selectDirtyFiltersFlag);

    useExportSearchTrigger(() => {
        dispatch(saveSearchTriggerModalToggledAction(true));
    }, isGuardConditionSatisfied);

    return { isGuardConditionSatisfied };
};

export default useSavedSearchTrigger;
